import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/shadcn/lib/utils";

const alertVariants = cva(
  "relative w-full rounded-lg border p-4 [&>svg]:absolute [&>svg]:top-4 [&>svg]:left-4 [&>svg]:text-foreground [&>svg+div]:translate-y-[-3px] [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        primary: "border-primary/60 border-transparent bg-primary text-white [&>svg]:text-white",
        white: "border-neutral-400 bg-white text-foreground [&>svg]:text-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground [&>svg]:text-secondary-foreground",
        accent:
          "border-transparent bg-accent text-accent-foreground [&>svg]:text-accent-foreground",
        muted: "border-transparent bg-muted text-muted-foreground [&>svg]:text-muted-foreground",
        info: "border-transparent bg-info/10 text-foreground [&>svg]:text-info",
        success: "border-transparent bg-success/10 text-foreground [&>svg]:text-success",
        warning: "border-transparent bg-warning/10 text-foreground [&>svg]:text-warning",
        error: "border-transparent bg-destructive/10 text-destructive [&>svg]:text-destructive",
        outline: "border-neutral-400 bg-transparent text-foreground [&>svg]:text-foreground",
        ageless: "border-transparent bg-ageless-amber text-white [&>svg]:text-white",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div
      className={cn(alertVariants({ variant }), className)}
      data-slot="alert"
      role="alert"
      {...props}
    />
  );
}
function AlertTitle({ children, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="alert-title" {...props}>
      <h5 className="type-label-md text-inherit">{children}</h5>
    </div>
  );
}
function AlertDescription({ children, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="alert-description" {...props}>
      <p className="type-body-sm text-inherit">{children}</p>
    </div>
  );
}
function AlertAction({ ...props }: React.ComponentProps<"div">) {
  return <div data-slot="alert-action" {...props} />;
}
export { Alert, AlertTitle, AlertDescription, AlertAction };
